module.exports = __webpack_public_path__ + "media/images/real-gminaradziejow-490713ee47fddaff80c534ea02ba1616.png";